import { render, staticRenderFns } from "./Bienvenida.vue?vue&type=template&id=3060c958&scoped=true&"
import script from "./Bienvenida.vue?vue&type=script&lang=js&"
export * from "./Bienvenida.vue?vue&type=script&lang=js&"
import style0 from "./Bienvenida.vue?vue&type=style&index=0&id=3060c958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3060c958",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCol,VImg,VRow})
